import { useContext } from "react";
import { InfoOutlined } from "@mui/icons-material";
import { Checkbox, FormControlLabel } from "@mui/material";
import classes from "./Setting.module.css";
import { DiscoveryContext } from "../discovery-context";

export default function PersonaSettings({
    setPersonaSettings,
    personaSettings
}) {
    const discoveryCtx = useContext(DiscoveryContext);
    const isFinalTransactionCompleted =
        discoveryCtx?.state.finalTransactionStatus === "COMPLETED" ||
        discoveryCtx?.state.finalTransactionStatus === "RETRY";

    const checkboxLabelStyles = {
        mb: 2,
        "&.MuiFormControlLabel-root": {
            display: "flex !important",
            flexDirection: "row !important",
            alignItems: "flex-start !important",
            padding: "1rem",
            border: "1px solid #e5e7eb",
            borderRadius: "0.75rem",
            margin: "0 !important",
            background: "white",
        },
        ".MuiFormControlLabel-label": {
            marginLeft: "10px !important",
            display: "flex !important",
            flexDirection: "column !important",
        }
    };

    const handleChange = (key, checked) => {
        setPersonaSettings(prev => ({
            ...prev,
            [key]: checked,
        }));
    };

    return (
        <div className={classes.personaSection}>
            <div className={classes.sectionHeader}>
                <div>
                    <h4 className={classes.sectionTitle}>
                        Persona Execution Settings
                        <InfoOutlined className={classes.infoIcon} titleAccess="These settings determine how personas are mapped during execution." />
                    </h4>
                    <p className={classes.sectionSubtitle}>
                        These settings determine how personas are mapped to categories and markets during execution.
                    </p>
                </div>
            </div>

            <div className={classes.checkboxContainer}>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={personaSettings.applyPersonaToAllCategory}
                            onChange={(e) => handleChange("applyPersonaToAllCategory", e.target.checked)}
                            disabled={discoveryCtx?.loading || isFinalTransactionCompleted}
                            sx={{
                                color: '#d1d5db',
                                '&.Mui-checked': {
                                    color: '#2dd4bf',
                                },
                                padding: '4px'
                            }}
                        />
                    }
                    label={
                        <div>
                            <strong className={classes.checkboxLabel}>
                                Apply personas across all selected categories
                            </strong>
                            <div className={classes.checkboxDescription}>
                                Every persona will run for all selected categories instead of only the primary category.
                            </div>
                        </div>
                    }
                    sx={checkboxLabelStyles}
                />

                <FormControlLabel
                    control={
                        <Checkbox
                            checked={personaSettings.applyPersonaToAllMarkets}
                            onChange={(e) => handleChange("applyPersonaToAllMarkets", e.target.checked)}
                            disabled={discoveryCtx?.loading || isFinalTransactionCompleted}
                            sx={{
                                color: '#d1d5db',
                                '&.Mui-checked': {
                                    color: '#2dd4bf',
                                },
                                padding: '4px'
                            }}
                        />
                    }
                    label={
                        <div>
                            <strong className={classes.checkboxLabel}>
                                Apply personas across all selected markets
                            </strong>
                            <div className={classes.checkboxDescription}>
                                Every persona will run for all selected markets instead of only the primary market.
                            </div>
                        </div>
                    }
                    sx={checkboxLabelStyles}
                />
            </div>
        </div>
    );
}